import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-trust-icons-page',
  templateUrl: './trust-icons-page.component.html',
  styleUrls: ['./trust-icons-page.component.scss']
})
export class TrustIconsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
